import { IStore } from 'store/types';
import { IntegrationCategory, ISiteIntegration } from 'types';

export const selectSite = () => (state: IStore) => state.site;

export const selectSiteSettings = () => (state: IStore) => state.site?.settings;

export const selectSiteAcceptance = () => (state: IStore) => state.site?.acceptance;

export const selectSitePOSIntegration =
  () =>
  (state: IStore): ISiteIntegration | undefined => {
    const categories = [IntegrationCategory.LABOR, IntegrationCategory.TICKET];
    return state.site?.integrations?.find((integration) => integration?.categories?.some((v) => categories.includes(v)));
  };

export const selectSiteAccountBalance = () => (state: IStore) => state.site?.accountBalance;

export const selectSiteAcceptanceBalance = () => (state: IStore) => state.site?.acceptanceBalance;
